module.exports = __webpack_public_path__ + "static/merino-wool-f0ef2d7f1d44cae8a84f1ae675f4e466.jpg";